import React, { ChangeEvent, FormEvent , useEffect, useRef, useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import InputField from "../../components/InputField/InputField";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import DatePicker from "react-datepicker";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import personStatus from "../../utils/constants/Dropdown.constants";
import setInputValues from "../../utils/helpers/setInputValue";
import { useLocation, useNavigate } from "react-router-dom";
import "./peopleform.scss";
import { postDetails, postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import encrypt from "../../utils/helpers/encrypt";
import formatDate from "../../utils/helpers/formatDate";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ArrowLeft } from "react-bootstrap-icons";
import Select from "react-select";
import {isDateGreaterThanToday} from "../../utils/helpers/isDateGreaterOrEqualToday";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { number } from "yup";
import { customStyles, customSingleSelectStyles} from "../../utils/constants/CustomStyles.constants";
import { format } from "date-fns";

interface People {
  id?: number;
  first_name: string;
  last_name: string;
  dob: string ;
  city: string;
  emp_code: string;
  is_Godmod?: 0|1|number;
  designation: string;
  email: string;
  mobileNo: string;
  status?: number;
  modified?: Date;
  Close_Date?: string;
}

const PeopleForm = () => {
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const [image, setImage] = useState<{value: any, src: string}>({value:null , src: ""})
  const isImageChanged = useRef(false)
  const dispatch = useAppDispatch();
  
  const location = useLocation();
  const isEdit = location.state?.isEdit || false

  const [initialFormState, setInitialFormState] = useState<People | null>(null)
  const [dobError, setDobError] = useState("")
  const [selectedOption, setSelectedOption] = useState(personStatus[0])
  const [selectedDob, setSelectedDob] = useState<Date | null>(null)
  const [selectedCloseDate, setSelectedCloseDate] = useState<Date | null>(null)

  const [personDetails, setPersonDetails] = useState<People>({
    first_name: "",
    last_name: "",
    designation: "",
    emp_code: "",
    email: "",
    mobileNo: "", 
    dob: "",
    city: "",
    status: 1,
    Close_Date: "",
  });
 
  
  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    
    if(isEdit){
      console.log(location.state.data)
      const { id, name, first_name, last_name, mobileNo, emp_code, email, city, dob, designation, status, Close_Date} = location.state.data
      
      // const filteredPersonDetails = { id, name, first_name, last_name, mobileNo, emp_code, email, city, dob, designation, Close_Date}

      setPersonDetails({
        id: location.state.data.id || "" ,
        first_name: location.state.data.first_name || "",
        last_name: location.state.data.last_name || "",
        designation: location.state.data.designation || "",
        emp_code: location.state.data.emp_code || "",
        email: location.state.data.email || "",
        mobileNo: location.state.data.mobileNo || "", 
        dob: location.state.data.dob || "",
        city: location.state.data.city || "",
        status: location.state.data.status || "",
        Close_Date: location.state.data.Close_Date ? formatDateString(location.state.data.Close_Date): "",
      });
      setInitialFormState({
        id: location.state.data.id || "",
        first_name: location.state.data.first_name|| "",
        last_name: location.state.data.last_name || "",
        designation: location.state.data.designation|| "",
        emp_code: location.state.data.emp_code|| "",
        email: location.state.data.email || "",
        mobileNo: location.state.data.mobileNo|| "", 
        dob: location.state.data.dob || "",
        city: location.state.data.city || "",
        status: location.state.data.status || "",
        Close_Date: location.state.data.Close_Date ? formatDateString(location.state.data.Close_Date): "",
      })
      setImage({
        ...image,
        src: location.state.data.profile || ""
      })
      // console.log(dob, Close_Date)
      setSelectedDob(dob ? new Date(dob): null)
      setSelectedCloseDate(Close_Date? new Date(Close_Date): null)
      setSelectedOption( status === 1 ? personStatus[0] : personStatus[1])
    } 
        
  }, []);
  
  const removeImage = ()=>{
    setImage({
      value: null, src: "",
    })
  }

  const handleChange = (selectedOption: any) => {
    setSelectedOption(selectedOption)
    setPersonDetails({
      ...personDetails,
      status: selectedOption.value
    })
  };

  // const handleDateChange = (ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //    const value = ev.target.value
  //    console.log("DOB", value)
  //    setSelectedDob(value)
  //     setPersonDetails({
  //       ...personDetails,
  //       dob: value,
  //     });
  // };

  const handleDobChange = (date: Date | null) => {
    setSelectedDob(date); // Set the selected date to state
    if(date){
      setPersonDetails((prevValue:People)=>({
      ...prevValue,
      dob: format(date, 'yyyy-MM-dd')
    }))
  }
  };

  const handleCloseDateChange = (date: Date | null) => {
    setSelectedCloseDate(date); // Set the selected date to state
    if(date){
      setPersonDetails((prevValue:People)=>({
      ...prevValue,
      Close_Date: format(date, 'yyyy-MM-dd')
    }))
  }
  else{
    setPersonDetails((prevValue:People)=>({
      ...prevValue,
      Close_Date: ""
    }))
  }
  };


  const submitDetails = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    // console.log(personDetails)
//     console.log("isImageChanged:", isImageChanged.current);
// console.log("Person details comparison:", JSON.stringify(personDetails) === JSON.stringify(initialFormState));
// console.log("Initial State",JSON.stringify(initialFormState))
// console.log("Later State",JSON.stringify(personDetails))

// console.log("Close Date",personDetails.Close_Date)
// console.log("Is date greater than or equal to today",isDateGreaterOrEqualToday(personDetails.Close_Date))
      // if(!isDateGreaterThanToday(selectedCloseDate)){
      //   alert("Close date should be greater than today")
      //   return
      // }

    if(isEdit){
    if (!isImageChanged.current && (JSON.stringify(personDetails) === JSON.stringify(initialFormState))) {
      dispatch(showToast("No changes done."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
     }

     const now = new Date();

     // Check if selected date is earlier than today
     if (selectedCloseDate && selectedCloseDate < now) {
       dispatch(showToast(`Close date should be later than today`));
       setTimeout(() => dispatch(hideToast()), 3000);
       return;
     }

     if (!selectedDob) {
      setDobError("Please select a date of birth");
      return; 
    }

    setDobError("");

    let payload: any;

    payload = {
      first_name: personDetails.first_name,
      last_name: personDetails.last_name,
      designation: personDetails.designation,
      emp_code: personDetails.emp_code,
      email: personDetails.email,
      mobileNo: personDetails.mobileNo, 
      dob: personDetails.dob,
      city: personDetails.city,
      status: personDetails.status,
    }

    if(personDetails.Close_Date){
      payload.Close_Date = personDetails.Close_Date
    }

    if(isEdit){
      payload.id = personDetails.id
    }

     const formData = new FormData();
     if(image.value){
       formData.append('mediafiles', image.value);
     }
     formData.append('data', encrypt(payload));

    try {
        const response = await postMultipartDetails(APIList.ADD_PEOPLE, formData);
        console.log("Response",response)
    
        if(response.statusCode === 200){
          navigate("/people")
          dispatch(showToast( isEdit ? "User Successfully Updated" : "User Successfully Added"));
          setTimeout(() => dispatch(hideToast()), 3000);
          setPersonDetails({
            first_name: "",
            last_name: "",
            designation: "",
            emp_code: "",
            email: "",
            mobileNo: "",
            dob: "",
            city: "",
            status: selectedOption.value,
            Close_Date: "",
          });
        }

       else if(response.Status === "Failed" || response.status === "Failed"){
          dispatch(showToast(`${response.message}`));
          setTimeout(() => dispatch(hideToast()), 7000);
          return
        }

       else if(response.status === 404){
          dispatch(showToast(`status 404: ${response.message}`));
          setTimeout(() => dispatch(hideToast()), 3000);
          return
        }

        else if(response.status === 500){
          dispatch(showToast("Server error occurred. Please try again later."));
          setTimeout(() => dispatch(hideToast()), 3000);
          return
        }

        else if(response.data.status === "Failed"){
          dispatch(showToast(response.message));
          setTimeout(() => dispatch(hideToast()), 3000);
          return
        }
        
     
    } catch (error) {
      console.log("Cannot add User", error)
      dispatch(showToast("An unexpected error occurred. Please try again later."));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  function formatDateString(dateString:string) {
    const date = new Date(dateString);
    
    // Get year, month, and day from the date object
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
  
    // Return formatted date as yyyy-mm-dd
    return `${year}-${month}-${day}`;
  }

  const formatDateForInput = (date: string) => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const formatDateForSaving = (date: string) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleCancel = () => {
    setSelectedOption(personStatus[0]);
    setPersonDetails({
      first_name: "",
      last_name: "",
      designation: "",
      emp_code: "",
      email: "",
      mobileNo: "",
      dob: "",
      city: "",
      status: 1,
      Close_Date: ""
    });

    navigate("/people");
  };

  const handleImageUpload = (ev: any)=>{
    const file = ev.target.files?.[0];
        if(file){
          isImageChanged.current = true
            const maxSize = 10.1 * 1024 *1024  // 10 MB maximum file size
            if( file.size > maxSize){
                dispatch(showToast("Image size should not exceed 10MB"));
                setTimeout(() => dispatch(hideToast()), 3000);
                return
            }
            const validation = validateImageFile(file);
            if( !validation.valid ){
                dispatch(showToast(validation.message));
                setTimeout(() => dispatch(hideToast()), 3000);
              }
              else{
                setImage({value: file, src: URL.createObjectURL(file)})
              }
  }
}

// const handleTextInput = (e: React.FormEvent<HTMLInputElement>) => {
//   const { name, value } = e.currentTarget;
//   setPersonDetails({
//       ...personDetails,
//       [name]: value.replace(/\d/g, '') 
//   });
// };

// const handleNumberInput = (e: React.FormEvent<HTMLInputElement>) => {
//   const { name, value } = e.currentTarget;
//   setPersonDetails({
//       ...personDetails,
//       [name]: value.replace(/\D/g, '') 
//   });
// };

  // Prevent numbers in text fields
  const handleKeyDownText = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/^[a-zA-Z]$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
      e.preventDefault();
  }
};

// Prevent non-numeric characters in number field
const handleKeyDownNumber = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
        e.preventDefault();
    }
};

  const buttons = [
    {
      label: "Back to People List",
      theme: "warning",
      icon: <ArrowLeft />,
      onClick: handleCancel,
    },
  ];

  const displayRemoveImageButton = ()=>{
    if(image.value || (image.src && !isEdit)){
    return (<span className="remove-image-btn font-14 cursor-pointer" onClick={removeImage}>Remove</span>)
 } 
 else return null;
}

  return (
    <LayoutContainer title={"Add People"}>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-flask"></i> 
          {isEdit ? "Edit People":"Add People"}
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div className="mx-4">
        <form onSubmit={submitDetails}>
        <div className="person-info-container">
            <div className="height-50px">
              <InputField
                name="first_name"
                label="First Name"
                type="text"
                value={personDetails.first_name}
                placeholder="First Name"
                minLength={1}
                maxLength={50}
                required={true}
                  pattern="[A-Za-z\s]+"
                onChangeInput={(ev) =>{
                  const value = ev.target.value;
                  if (/^[A-Za-z\s]*$/.test(value)) {  // Only allow alphabets and spaces
                    setInputValues(ev, personDetails, setPersonDetails);
                  }
                }}
              />
              </div>

          <div className="height-50px">
          <InputField
            name="last_name"
            label="Last Name"
            type="text"
            value={personDetails.last_name}
            placeholder="Last Name"
            minLength={0}
            maxLength={50}
              pattern="[A-Za-z\s]+"
              
            required={false}
            onChangeInput={(ev) =>{
              const value = ev.target.value;
              if (/^[A-Za-z\s]*$/.test(value)) {  
              setInputValues(ev, personDetails, setPersonDetails)
              }
            }}
          />
          </div> 

          <div className="height-50px">
          <InputField
            name="designation"
            label="Designation"
            type="text"
            value={personDetails.designation}
            placeholder="Designation"
            minLength={1}
            maxLength={50}
            required={true}
            // pattern="[A-Za-z\s]+"
            onChangeInput={(ev) =>{
              const value = ev.target.value;
              if (/^[A-Za-z\s&?()-]*$/.test(value)) { 
                setInputValues(ev, personDetails, setPersonDetails);
              }
            }}
          />
          </div>

          <div className="height-50px">
          <InputField
            name="emp_code"
            label="Employee Code"
            type="text"
            value={personDetails.emp_code}
            placeholder="Employee Code"
            minLength={3}
            maxLength={9}
            required={true}
            onChangeInput={(ev) =>{
               const value = ev.target.value;
              if (/^[A-Za-z0-9]*$/.test(value)){
              setInputValues(ev, personDetails, setPersonDetails)
            }}
            }
          />
          </div>
        </div>

        <h2 className="text-warning fw-bold fs-4 mb-4">Upload Information</h2>
        <div className="upload-information mb-4">
          <p className="font-14 mb-4">Uploads must be JPG / JPEG / PNG</p>
          <div className="mb-2">
            <div className="upload-image-wrapper d-flex flex-column">
            {/* {image.src && !isEdit && <span className="remove-image-btn font-14 cursor-pointer" onClick={removeImage}>Remove</span>} */}
            { displayRemoveImageButton() }
            {image.src && <img src={image.src} alt="people-image" width={150} />}
            </div>
          </div>
          <label htmlFor="photo">
            <div className="upload-btn-wrapper font-14 d-flex align-items-center justify-content-center gap-1">
              <i className="fa-regular fa-image"></i>
              <span>{image.src ? "Change Photo" : "People Logo"}</span>
            </div>
          </label>
          <InputField
            type="file"
            name="photo"
            id="photo"
            value={""}
            className="d-none"
            onChangeInput={handleImageUpload}
          />
        </div>

        <h2 className="text-warning fw-bold fs-4 mb-4">General Information</h2>
        <div className="general-information">

        <div className="height-50px">
          <InputField
            name="email"
            label="Contact Email ID"
            type="email"
            value={personDetails.email}
            placeholder="Contact Email ID"
            minLength={3}
            maxLength={50}
            required={true}
            onChangeInput={(ev) =>
              setInputValues(ev, personDetails, setPersonDetails)
            }
          />
          </div>

          <div className="height-50px">
          <InputField
            name="mobileNo"
            label="Mobile Number"
            type="text"
            value={personDetails.mobileNo}
            placeholder="Mobile Number"
            minLength={10}
            maxLength={10}
            required={true}
            className={"no-arrows"}
            onKeyDown={handleKeyDownNumber}
            onChangeInput={(ev) =>
              setInputValues(ev, personDetails, setPersonDetails)
            }
          />
          </div>

          <div className="height-50px font-12">
           <div> <label htmlFor="dob" className="d-block mb-1 weight-500">DOB <span className="text-danger">*</span></label></div>
            <DatePicker
            id="dob"
            name="dob"
            selected={selectedDob}
            onChange={handleDobChange}
            dateFormat="dd-MM-yyyy"
            showMonthDropdown  // Add month dropdown
            showYearDropdown   // Add year dropdown
            dropdownMode="select"
            maxDate={new Date()}
            onKeyDown={(e:any)=> {e.preventDefault()}}
            placeholderText="DOB"
            className={`mf-admin-inputfield`}
            // onBlur={handleDatePickerOnBlur}
            // required={true}
            isClearable
          />
          {/* <InputField
                type="date"
                name="dob"
                id="dob"
                value={selectedDob}
                onChangeInput={handleDateChange}
                required={true}
              /> */}
          { dobError && (<p className="error-text font-12 mt-1">{dobError}</p>)}
          </div>

          <div className="height-50px">
          <InputField
            name="city"
            label="City"
            type="text"
            value={personDetails.city}
            placeholder="City"
            minLength={3}
            maxLength={50}
            
            required={true}
            onKeyDown={handleKeyDownText}
            // onInput={handleTextInput}
            onChangeInput={(ev) =>
              setInputValues(ev, personDetails, setPersonDetails)
            }
          />
          </div>

          <div className="height-50px font-12">
           <label htmlFor="status" className="d-block mb-1 weight-500">Status</label>
          <Select
            styles={customStyles}
            id="status"
            name="status"
            options={personStatus}
            value={selectedOption}
            onChange={handleChange}
            placeholder="Select Status"
          />
          </div>

          <div className="height-50px font-12">
            {/* Optional field */}
           <div> <label htmlFor="Close_Date" className="d-block mb-1 weight-500">Close Date</label></div>
          {/* <InputField
                type="date"
                name="Close_Date"
                id="Close_Date"
                value={selectedCloseDate}
                onChangeInput={handleCloseDateChange}
              /> */}
              <DatePicker
            id="Close_Date"
            name="Close_Date"
            selected={selectedCloseDate}
            onChange={handleCloseDateChange}
            dateFormat="dd-MM-yyyy"
            showMonthDropdown  // Add month dropdown
            showYearDropdown   // Add year dropdown
            dropdownMode="select"
            minDate={new Date()}
            onKeyDown={(e:any)=> {e.preventDefault()}}
            placeholderText="Close Date"
            className={`mf-admin-inputfield`}
            // onBlur={handleDatePickerOnBlur}
            // required={true}
            isClearable
          />
          {/* { dobError && (<p className="text-danger">{dobError}</p>)} */}
          </div>
         
        </div>
        <div className="addpeople-btn-bottom d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-5">
          <CustomButton theme="red" size="md" onClick={handleCancel}>
            Cancel
          </CustomButton>
          <CustomButton theme="yellow" size="md" type="submit">
          Submit
          </CustomButton>
        </div>
        </form>
      </div>
    </LayoutContainer>
  );
};

export default PeopleForm;
